// Single source of truth for the recruiter "screen me" prompt and profile URLs.
// The prompt is HARDENED against fabrication: a non-browsing model must admit it
// cannot access the profile rather than hallucinate an assessment.

export const PROFILE_PAGE_URL = "https://nishanttiwari.com/hire"
export const DISCOVERY_URL = "https://nishanttiwari.com/.well-known/ai-profile.json"
export const FULL_PROFILE_URL = "https://nishanttiwari.com/api/profile.json"

export const SCREEN_PROMPT = `Screen this candidate for the role below. Read the candidate's full profile at ${PROFILE_PAGE_URL} (the profile is on that web page; structured JSON is also at ${FULL_PROFILE_URL}). If you cannot access it, tell me and stop — do NOT guess or rely on prior knowledge. If you can read it, be critical and objective: list strengths, gaps, and a clear hire verdict.

Role: <paste the job description here>`
